import type { SVGProps } from 'react';

interface DashIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const DashIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & DashIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 21 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      clipRule="evenodd"
      d="M20.152 10c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10M6.902 9a.75.75 0 0 0 0 1.5h6.5a.75.75 0 1 0 0-1.5z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
